export function sortFilteredList(query, filteredServicesCollection){
  const {sortBy,sortType}=query;
  let sortedList=[];
  if (sortBy==='departure'){
    sortedList=filteredServicesCollection.sort((a,b)=>{
        if(sortType==='asc'){
          return a.first_boarding_time - b.first_boarding_time;
        }
        else{
          return b.first_boarding_time - a.first_boarding_time;
        }
    })
  } 
  if (sortBy === 'rating') {
    sortedList = filteredServicesCollection.sort((a, b) => {
      a = a.rnr && a.rnr.rating_details && a.rnr.rating_details.average_rating;
      b = b.rnr && b.rnr.rating_details && b.rnr.rating_details.average_rating;
      a = !a ? -Infinity : a;
      b = !b ? -Infinity : b;
      if (sortType === 'asc') {
        return a - b;
      }
      else {
        return b - a;
      }
    })
  }
  if (sortBy === 'change') {
    sortedList = filteredServicesCollection.sort((a, b) => {
      a = a.rnr && a.rnr.rating_details && a.rnr.rating_details.fifteen_days_change;
      b = b.rnr && b.rnr.rating_details && b.rnr.rating_details.fifteen_days_change;
      a = !a ? -Infinity : a;
      b = !b ? -Infinity : b;
      if (sortType === 'asc') {
        return a - b;
      }
      else {
        return b - a;
      }
    })
  }
  
  return sortedList;
}